<template>
    <div>
        <select id="pays" name="pays_id" class="kt_select2 col-12 px-0" data-live-search="true" title="Pays"
            data-style="select-with-transition" v-model="selected_pays">
            <option v-for="p in pays" :key="`pays_${p.id}`" :value="p.id">{{ p.nom }}</option>
        </select>
        <select id="villes" name="ville_id" class="kt_select2 col-12 px-0" data-live-search="true" title="Ville"
            data-style="select-with-transition" v-model="selected_ville">
                <option v-for="ville in villes" :key="`ville_${ville.id}`" :value="ville.id">{{ ville.nom }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            api_token: String,
            init_pays: Number,
            init_ville: Number,
        },
        data() {
            return {
                villes: [],
                pays: [],
                selected_pays: null,
                selected_ville: null,
                config: {
                    'headers': {
                        'Authorization': `Bearer ${this.api_token}`
                    }
                }
            }
        },
        watch: {
            selected_pays: function(val) {
                var data = {
                    id: this.selected_pays,
                };
                axios.post('/api/villes', data, this.config)
                .then(res => {
                    this.villes = res.data;
                }).finally(() => {
                    $("#villes").select2().trigger('refresh');
                });
            }
        },
        mounted() {
            axios.get('/api/pays', this.config)
            .then(res => {
                this.pays = res.data;
            });
        },
        created() {
            this.selected_pays = this.init_pays;
            this.selected_ville = this.init_ville;
            setTimeout(function() {
                $("#pays").select2().trigger('refresh');
            }, 1000);
        }
    }

</script>

<style>

</style>
